var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosnf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "297mm",
    viewBox: "0 0 210 297",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#eee",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 111.62,
    cy: 141.13,
    r: 70.14,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.91841 0 0 .91841 10.071 10.895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.823 185.47s10.746 1.8485 16.155 1.6359c9.6868-0.3808 15.746-3.8853 15.746-3.8853l0.20449-66.05s-17.072 1.676-25.357 0c-4.6408-0.93884-10.9-1.322-13.087-5.5212-0.90176-1.7311-0.0387-4.2398 1.2269-5.7257 3.4144-4.0088 9.5698-4.6435 14.723-5.7257 7.7453-1.6265 23.721-1.0224 23.721-1.0224h-0.20449",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.541 118.4 33.332 61.96 0.40898-78.728 29.242 0.20449",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.71 127.4h23.312",
    strokeWidth: 9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosnf);
export default __webpack_public_path__ + "static/media/LOGOSNF.391f671e2a715bab5c8d4cc36fb8e6ab.svg";
export { ForwardRef as ReactComponent };